export default __webpack_public_path__ + "static/jay-12d3d43006e7f71afd2ef18c6485f133.png";